import { Components, ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import styled from "styled-components";

import { useContainerSize } from "../../../../../hooks/useContainerSize";
import { useAppSelector } from "../../../../../redux";
import { FlexColumn, hideScrollbar } from "../../../../Common/Styles";
import { TitleAndButton } from "./TitleAndButton";

export const PeopleYouMayKnow = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);
  const { height: headerHeight } = useContainerSize(headerRef);
  const { peopleYouMightKnow } = useAppSelector((state) => state.me);

  return (
    <Container
      $gapInPx={10}
      $height={isOpen ? headerHeight + 416 : headerHeight + 18}
      $isOpen={isOpen}
    >
      <TitleAndButton
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        headerRef={headerRef}
      />
      <ContentContainer $gapInPx={8}>
        {peopleYouMightKnow.map((people, index) => (
          <Components.ListItem
            key={index}
            type="List Item"
            label={people.first_name + " " + people.last_name}
            rightButtonLabel="Follow"
            rightButtonOnClick={() => {}}
            onClick={() => {}}
            showRightButton
            avatarSrc={people.profile_picture}
            avatarType="Circle"
          />
        ))}
      </ContentContainer>
    </Container>
  );
};

const Container = styled(FlexColumn)<{ $height: number; $isOpen: boolean }>`
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme, $isOpen }) =>
      $isOpen
        ? theme.Color.border["ui-border-emphasize-brand"].value
        : theme.Color.border["ui-border-subtle"].value};
  max-height: ${({ $height }) =>
    ThisGorillaUtils.convertPxToRem(String($height))}rem;
  transition: all 300ms ease-in-out;
  overflow: hidden;
  background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(30, 150, 242, 0.08) 100%
    ),
    #fff;
`;

const ContentContainer = styled(FlexColumn)`
  max-height: ${ThisGorillaUtils.convertPxToRem("388")}rem;
  overflow-y: auto;
  ${hideScrollbar}
`;
